import jwtAuthAxios from "./auth/jwtAuth";

const vehicleServices = {};

vehicleServices.getNewVehicle = async (params) => {
    const {data} = await jwtAuthAxios.get(`/vehicles/new${params ?? ""}`);
    return data;
}

vehicleServices.createVehicle = async (params, body) => {
    const {data} = await jwtAuthAxios.post(`/vehicles${params ?? ""}`, body);
    return data;
}

vehicleServices.getVehicles = async (params=null) => {
    const {data} = await jwtAuthAxios.get(`/vehicles${params || ""}`);
    return data;
};

vehicleServices.getVehicle = async (id, params=null) => {
    const {data} = await jwtAuthAxios.get(`/vehicles/${id}${params || ""}`);
    return data;
};

vehicleServices.getEditOptions = async () => {
    const {data} = await jwtAuthAxios.get(`/vehicles/edit_options`);
    return data;
};

vehicleServices.saveVehicle = async (id, params, body) => {
    const {data} = await jwtAuthAxios.put(`/vehicles/${id}${params ?? ""}`, body);
    return data;
}

// Endpoint propio: `PUT /vehicles/:id` exige la patente en el payload y reasigna las
// unidades de transporte, asi que no sirve para guardar solo la configuracion de ruteo.
vehicleServices.saveVehicleRoutingSettings = async (id, body) => {
    const {data} = await jwtAuthAxios.patch(`/vehicles/${id}/routing_settings`, body);
    return data;
};

vehicleServices.toggleVehicleActivation = async (id, params=null) => {
    const {data} = await jwtAuthAxios.post(`/vehicles/${id}/toggle_activation${params || ""}`);
    return data;
};

// vehicleServices.saveCustomerGeofence = async (id, params) => {
//     const {data} = await jwtAuthAxios.post(`/customers/${id}/geofence`, params);
//     return data;
// };

// vehicleServices.getReceiptsPins = async (id) => {
//     const {data} = await jwtAuthAxios.get(`/customers/${id}/receipts_pins`);
//     return data;
// };

vehicleServices.deleteVehicle = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/vehicles/${id}`);
    return data;
};

export default vehicleServices;
